import { Collection } from '@nozbe/watermelondb';

import {
    ProductInvoiceModel,
    ProductInvoicePayload,
} from '../../../../types/Products';
import { DBWriterLoggerFunction } from '../../../../types/logger';

const normalizePrice = (price: string) => price.replace(',', '.');

const prepareCreateProduct = ({
    collection,
    payload,
    userId,
    organisationId,
}: {
    collection: Collection<ProductInvoiceModel>;
    payload: ProductInvoicePayload;
    userId: string;
    organisationId: string;
}) => {
    const productPrice = normalizePrice(payload.price);

    return collection.prepareCreate((product) => {
        product.name = payload.name;
        product.price = productPrice;
        product.available = payload.available;
        product.organisationId = organisationId;
        product.userId = userId;
    });
};

const logAddDBActions = ({
    product,
    logDBAction,
    tableName,
}: {
    product: ProductInvoiceModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Create invoicing product',
        modelName: tableName,
        payload: product,
    });
};

export { prepareCreateProduct, logAddDBActions };
